export const enum ReferenceType {
    GENDER = 99,
    EVENT_TYPE = 100,
    CURRENCY = 101,
    PARAMETER_TYPE = 102,
    REQUISITE_TYPE = 103,
    CONTACT_TYPE = 104,
    TERMINAL_ATTRIBUTE_TYPE = 105,
    FLOW_TYPE = 200,
    PAYMENT_STATUS = 201,
    TRANSACTION_STATUS = 202,
    TRANSACTION_TYPE = 203,
    TICKET_ISSUE_TYPE = 107,
    TICKET_STATUS = 204,
    FEE_TYPE = 106,
    NOTIFICATION_TYPE = 108,
    SBP_BANK_NAME = 205,
    PAYMENT_CHANNEL_TYPE = 110,
    CHANNEL_INTEGRATION_TYPE = 111,
    CLIENT_COHORTS = 112,
    TERMINAL_POOL_STATUS = 113,
    TERMINAL_POOL_TYPE = 114
}

// const references: Reference[] = [
//     { id: ReferenceType.GENDER, name: "Пол" },
//     { id: ReferenceType.EVENT_TYPE, name: "Тип события" },
//     { id: ReferenceType.CURRENCY, name: "Валюта" },
//     { id: ReferenceType.PARAMETER_TYPE, name: "Тип параметра" },
//     { id: ReferenceType.REQUISITE_TYPE, name: "Тип реквизита" },
//     { id: ReferenceType.CONTACT_TYPE, name: "Тип контакта" },
//     { id: ReferenceType.TERMINAL_ATTRIBUTE_TYPE, name: "Тип атрибута терминала" },
//     { id: ReferenceType.FLOW_TYPE, name: "Направление платежа" },
//     { id: ReferenceType.PAYMENT_STATUS, name: "Статус платежа" },
//     { id: ReferenceType.TRANSACTION_STATUS, name: "Статус транзакции" },
//     { id: ReferenceType.TRANSACTION_TYPE, name: "Тип транзакции" },
//     { id: ReferenceType.TICKET_ISSUE_TYPE, name: "Тип проблемы в тикете" },
//     { id: ReferenceType.TICKET_STATUS, name: "Статус тикета" },
//     { id: ReferenceType.FEE_TYPE, name: "Тип комиссии" },
//     { id: ReferenceType.NOTIFICATION_TYPE, name: "Тип уведомления" },
//     { id: ReferenceType.SBP_BANK_NAME, name: "Название банка в СБП" },
//     { id: ReferenceType.PAYMENT_CHANNEL_TYPE, name: "Тип платежного канала" },
//     { id: ReferenceType.CHANNEL_INTEGRATION_TYPE, name: "Тип интеграции канала" },
//     { id: ReferenceType.CLIENT_COHORTS, name: "Когорты клиентов" },
//     { id: ReferenceType.TERMINAL_POOL_STATUS, name: "Статус пула терминалов" },
//     { id: ReferenceType.TERMINAL_POOL_TYPE, name: "Тип пула терминалов" }
// ];